import { UpsertUserConfigDto, UserConfigDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/user-config`;

export const saveUserConfig = (upsertUserConfigDto: Partial<UpsertUserConfigDto>,
                               source: CancelTokenSource): Promise<UserConfigDto> => {
  return axios
      .post(apiUri, upsertUserConfigDto, {cancelToken: source.token})
      .then(response => response.data);
};
